"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Link = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _urlify = require("../../html/urlify");

var _router = require("@reach/router"); // import { Link as RsLink, NavLinkProps } from "react-router-dom";


var Link =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Link, _Component);

  function Link(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = Link.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        to = _this$props.to,
        href = _this$props.href,
        otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["to", "href"]);

    if (href) {
      to = href;
    } // Make link conform to our url
    // TODO: only modify internal links?


    to = (0, _urlify.urlify)(to);
    return _react.default.createElement(_router.Link, (0, _extends2.default)({
      to: to
    }, otherProps));
  };

  return Link;
}(_react.Component);

exports.Link = Link;